import Vue from "vue"

Vue.filter("money", function (value) {
  return new Intl.NumberFormat("fr-CA", { style: "currency", currency: "CAD", currencyDisplay: "narrowSymbol" }).format(value)
})

Vue.filter("date", function (value) {
  let date = new Date(value)
  return date.toLocaleDateString()
})

Vue.filter("datelong", function (value) {
  let date = new Date(value)
  return date.toLocaleDateString("fr-CA", { dateStyle: "long" })
})

Vue.filter("dateJourMois", function (value) {
  let date = new Date(value)
  return date.toLocaleDateString("fr-CA", { month: "long", day: "numeric" })
})
